import tw from 'twin.macro';

export const Primary = tw.button`md:px-4 px-3 py-2 md:py-4 md:text-lg
font-normal bg-[#1a73e3] tracking-wide rounded-xl`;
